import styled from 'styled-components'

export const Modal = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${props => props.zIndex || '9999'};
  padding: 20px;

  background-color: rgba(255, 255, 255, .74);
  opacity: 0;
  pointer-events: none;

  transition: .3s;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    backdrop-filter: blur(8px);
    z-index: -1;
  }

  &.active {
    opacity: 1;
    pointer-events: unset;
    overflow-y: auto;
  }

  /* scrollbar-color: var(--grey) rgb(207,214,225) !important; // Firefox
  scrollbar-width: thin !important; // Firefox

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-track {
    background: rgb(207,214,225);
    background: linear-gradient(90deg, rgba(207,214,225,0) 20%, rgba(207,214,225,1) 20%, rgba(207,214,225,1) 80%, rgba(207,214,225,0) 80%);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--grey);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--grey);
  } */
`

export const Content = styled.div`
  position: relative;
  width: fit-content;
  min-width: ${props => props.width || '340px'};
  margin: auto;
  padding: 21px 49px 42px 49px;

  background-color: var(--white);
  border-radius: 10px;

  -webkit-box-shadow: 0px 3px 99px 0px var(--shadowPrimary);
  -moz-box-shadow: 0px 3px 99px 0px var(--shadowPrimary);
  box-shadow: 0px 3px 99px 0px var(--shadowPrimary);

  @media (max-width: 1050px) {
    min-width: unset;
    padding: 21px 20px 42px 20px;
  }

  @media (max-width: 875px) {
    max-width: 100%;
  }

  @media (max-width: 680px) {
    width: 100%;
  }
`

export const Internal = styled.div`
  min-width: 546px;

  @media (max-width: 680px) {
    min-width: unset;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const Header = styled.div`
  padding-top: 10px;
  padding-bottom: 15px;

  @media (max-width: 1050px) {
    padding-top: 5px;
  }
`

export const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  color: var(--text);
  margin-bottom: 10px;

  @media (max-width: 1050px) {
    font-size: 16px;
  }
`

export const Subtitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: var(--text);
  margin-top: -10px;
  margin-bottom: 10px;
`

export const BtnClose = styled.div`
  position: absolute;
  top: 25px;
  right: 30.6px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;

  background-color: var(--primary);
  border-radius: 50%;
  border-width: 0;

  cursor: pointer;
  transition: .3s;

  @media (max-width: 1050px) {
    width: 25px;
    height: 25px;

    & svg {
      width: 13px;
      height: 13px;
    }
  }
`

export const Separator = styled.div`
  width: 100%;
  border-top: 1px solid var(--hawkesBlue);
  margin-top: 12px;

  @media (max-width: 1050px) {
    margin-top: 0px;
  }
`

export const Body = styled.div`
  padding-top: 15px;
  overflow: auto hidden;

  p {
    display: block;
    max-width: 539px;
    margin-bottom: 15px;

    font-family: 'Poppins', sans-serif;
    font-size: 15px;
    line-height: 17px;
    color: var(--greyLight);
  }
`
